import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../service/auth/auth.service';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.css']
})
export class LogoutComponent implements OnInit {

  constructor(
    private authService: AuthService
  ) { }

  ngOnInit(): void {
    this.disableBrowserButtons();
  }

  disableBrowserButtons() {
    window.location.hash = "no-back-button";
    window.location.hash = "Again-No-back-button";
    window.onhashchange=function(){window.location.hash="no-back-button";}
  }

  ngOnDestroy(): void {
    this.authService.logout().subscribe((res) => {});
  }

}